/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  const hoverStyles = {
    "& .versionInfo": {
      height: 0,
      opacity: 0,
    },
    "& .api-card-content": {
      maxHeight: "100px",
      overflow: "hidden",
    },
  };

  const cardBaseStyles = {
    display: "flex",
    flexDirection: "column",
    maxWidth: theme.spacing(34.5),
    transition: "0.2s",
    ...theme.custom.elements.apiCard.styles,
  };

  return {
    card: {
      ...cardBaseStyles,
      "&:hover": {
        ...theme?.custom.elements.apiCard.styles["&:hover"],
        ...hoverStyles,
      },
    },
    noHoverCard: {
      ...cardBaseStyles,
      cursor: "default",
      "&:hover": hoverStyles,
    },
    versionInfo: {
      transition: "0.2s ease",
      opacity: 1,
    },
    cardDiv: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    cardContent: {
      flexGrow: 1,
      maxWidth: theme.spacing(30.25),
      ...theme.custom.elements.apiCard.content,
      paddingTop: theme.spacing(0.5),
      maxHeight: 50,
      overflow: "hidden",
      transition: "0.2s",
    },
    cardContentWrapper: {
      height: theme.spacing(13),
    },
    apiIconImage: {
      ...theme.custom.elements.apiCard.icon,
      textTransform: "capitalize",
    },
    cardHeader: {
      textAlign: "left",
      alignItems: "flex-start",
      height: theme.spacing(10),
    },
    cardHeaderPrototype: {
      paddingBottom: theme.spacing(0.5),
    },
    cardHeaderTitle: {
      overflowWrap: "anywhere",
      ...theme.custom.elements.apiCard.title,
    },
    cardheaderSubTitle: {
      marginTop: "0px",
    },
    cardHeaderTitleSkeleton: {
      marginBottom: 6,
    },
    cardActionRoot: {
      padding: "16px",
      justifyContent: "center",
    },
    cardActionRootPrototype: {
      paddingTop: theme.spacing(0.5),
    },
    cardActionSkeleton: {
      marginTop: 16,
    },
    tryOutButton: {
      ...theme.custom.elements.apiCard.tryOutButton,
    },
    docsButton: {
      ...theme.custom.elements.apiCard.docsButton,
    },
    lifecycleStatus: {
      ...theme.custom.elements.apiCard.lifecycleStatus,
      boxSizing: "border-box",
      border: "1px solid #8D91A3",
      fontSize: "10px",
      backgroundColor: "#E0E2E9",
      padding: "2px 10px",
      borderRadius: "5px",
    },
    apiType: {
      ...theme.custom.elements.apiCard.apiType,
      fontSize: 11,
    },
    apiTitle: {
      overflow: "hidden",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      display: "-webkit-box",
    },
    lsStatusWrapper: {
      marginLeft: theme.spacing(1),
    },
    rating: {
      ...theme.custom.elements.apiCard.rating,
      marginTop: theme.spacing(0.2),
    },
    versionWrapper: {
      ...theme.custom.elements.apiCard.versionWrapper,
      padding: `${theme.spacing(2)}px 0 0 ${theme.spacing(2)}px`,
    },
  };
});
